"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_intersection_observer_1 = require("react-intersection-observer");
var Header_1 = require("../Header");
var TextCaptionWrapper_1 = require("./TextCaptionWrapper");
var BackgroundImage_1 = require("./BackgroundImage");
var TileWrapper_1 = require("./TileWrapper");
var Caption_1 = require("./Caption");
var lauterbad_common_1 = require("@eimerreis/lauterbad-common");
var LinkWrapper_1 = require("../LinkWrapper");
var react_1 = require("react");
var ExtendedCaption = styled_components_1["default"](Caption_1.Caption)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ":hover & {\n        background-position: 0 100%;\n    }\n"], ["\n    ", ":hover & {\n        background-position: 0 100%;\n    }\n"])), TileWrapper_1.TileWrapper);
exports.SmallMetroTile = function (props) {
    var blok = props.blok;
    var _a = react_intersection_observer_1.useInView({
        triggerOnce: true,
        rootMargin: "500px 0px"
    }), ref = _a[0], inView = _a[1];
    var _b = react_1.useState("1920x0"), transformation = _b[0], setTransformation = _b[1];
    react_1.useEffect(function () {
        var width = lauterbad_common_1.WindowService.GetWindowDimensions().width;
        var transformedWith = width > 1920 ? width / 1.5 : width;
        setTransformation(transformedWith.toFixed(0) + "x0");
    }, []);
    return (React.createElement(TileWrapper_1.TileWrapper, { ref: ref, width: [1, 1 / 2] }, inView &&
        React.createElement(LinkWrapper_1.LinkWrapper, { internal: lauterbad_common_1.IsInternalLink(blok.link.cached_url), link: blok.link.cached_url },
            React.createElement(BackgroundImage_1.BackgroundImage, { filters: "filters:quality(90)", size: transformation, src: blok.image }),
            React.createElement(TextCaptionWrapper_1.TextCaptionWrapper, null,
                props.blok.caption ?
                    React.createElement(ExtendedCaption, null, props.blok.caption)
                    : React.createElement(React.Fragment, null),
                React.createElement(Header_1.Header, null, props.blok.text)))));
};
var templateObject_1;
